(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-subcollection"]) return;
  try {
    

$(document).ready(function(){  
	
    $( ".subcollections-title" ).click(function(event) {	
	event.stopPropagation();
    var $content = $(this).next('.subcollections-options-wrapper');	
    $content.toggleClass("show-in").slideToggle();
    $(this).toggleClass('active');    
    });

    var viewportWidth = $(window).width();
    if (viewportWidth < 768) {                            
         $(".subcollections-options-wrapper").removeClass("show-in").hide();
    }
                            
    $(".subcollections-option a:contains('fifa')").each(function() {
        $(this).html(function(index, text) {
            return text.replace('fifa', 'FIFA');
        });
    });
    

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
